import styled from 'styled-components';

export const StyledDiv = styled.div`
  padding: 1rem;
  margin: 1rem;
`;
